module.exports = __webpack_public_path__ + "static/Lato-Black-2614e8d8d7c5e959a499d213fe22aca3.woff";